import { Tooltip } from 'bootstrap';

// Disabled controls do not reliably receive hover/focus events. Their wrapper
// remains interactive and can explain why the action is unavailable.
export function updateToolAvailabilityTooltip(button, title) {
  const wrapper = button?.closest?.('.pc-selection-tool');
  if (!wrapper) return;

  Tooltip.getInstance(button)?.dispose();
  button.removeAttribute('data-bs-toggle');
  button.removeAttribute('title');
  button.setAttribute('aria-label', title);
  button.style.pointerEvents = button.disabled ? 'none' : '';

  wrapper.setAttribute('data-bs-toggle', 'tooltip');
  wrapper.setAttribute('tabindex', button.disabled ? '0' : '-1');
  wrapper.setAttribute('role', 'group');
  wrapper.setAttribute('aria-label', title);
  const previousTitle = wrapper.dataset.availabilityTooltip;
  wrapper.dataset.availabilityTooltip = title;
  const tooltip = Tooltip.getOrCreateInstance(wrapper, {
    container: document.body,
    trigger: 'hover focus',
    placement: 'top',
    title: () => wrapper.dataset.availabilityTooltip,
  });
  if (previousTitle !== title) {
    tooltip.setContent({ '.tooltip-inner': title });
  }
}
